import { Dialog, DialogContent, Box } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import tickImg from "../../Assets/images/blue-tick.png";
import errorOutline from "../../Assets/images/error-outline.svg";
import errorOutlineOrange from "../../Assets/images/error-triangle-orange.svg";
import "./style.scss";
import { RootState } from "../../Redux/Reducers";
import { useDispatch, useSelector } from "react-redux";
import { useSubscriptionDetailsSuite } from "../../Hooks/useSubscriptionDetailsSuite";
import { SubscriptionExpiryFooter } from "../SubscriptionExpiryFooter";
import { toggleSubscriptionExpireModal } from "../../Redux/Actions";
import { getSubscriptionExpireText } from "../../Utils/subscription";
import { isOwner } from "../../Utils/isOwner";

const data = [
  "Advance eCommerce Feature",
  "Easy Market Integration Tools",
  "Business Growth Tools",
  "End to End Customer Relationship Management tools",
];

const CustomDialog = withStyles({
  root: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "470px",
    },
    "& .MuiPaper-rounded": {
      borderRadius: 8,
    },
  },
})(Dialog);

export default function SubscriptionExpireModal() {
  const dispatch = useDispatch();
  const { showModal, storeData } = useSelector((state: RootState) => ({
    showModal: state.subscriptionReducer.showSubscriptionExpireModal,
    storeData: state.storeReducer.store,
  }));
  const { subscriptionStatus } = useSubscriptionDetailsSuite();

  const closeModal = () => dispatch(toggleSubscriptionExpireModal(false));

  const _RenderSelectedFooter = (): JSX.Element => {
    if (isOwner()) {
      return (
        <SubscriptionExpiryFooter
          className="ds-mt34"
          buttonLarge={true}
          afterRenewCallback={closeModal}
          beforeShowOffers={closeModal}
        />
      );
    }
    return (
      <p className="fw4 tc ds-mt34 mb0 ">
        Please ask your store owners to renew
        <br /> Ecommerce Pro pack to continue using this app
      </p>
    );
  };

  const subscriptionExpireText = getSubscriptionExpireText();

  return (
    <CustomDialog open={showModal} maxWidth="sm" fullWidth scroll="body" className="relative" onClose={closeModal}>
      <DialogContent className="subscription-expiry-modal-wrapper ds-p44 flex flex-column items-center tc">
        <img src={subscriptionStatus.isExpired ? errorOutline : errorOutlineOrange} alt="" width={"60px"} />
        <h2 className="ds-c44454A">{subscriptionExpireText}</h2>
        <div
          className="w-100 ds-pt24 ds-pb4"
          style={{
            borderTop: "0.8px solid #E2E2E2",
            borderBottom: "0.8px solid #E2E2E2",
          }}
        >
          {data.map((label: string) => 
            <div className="flex items-center ds-mb20 fw4" key={label}>
              <img src={tickImg} width={20} />
              <p className="mv0 ds-ml6">{label}</p>
            </div>,
          )}
        </div>
        {_RenderSelectedFooter()}
      </DialogContent>
    </CustomDialog>
  );
}
